/**
 * Scenario.js
 * 
 * Created on 26-sep-2013, 14:34:29
 *
 * @author Ivo Swartjes for Ranj
 **/
export default class ScenarioPlayerEvent {
    constructor(type, content, contentPlayer) {
        this.type = type;
        this.content = content;
        this.contentPlayer = contentPlayer;
    };

}

ScenarioPlayerEvent.QUIZ_AVAILABLE = "ScenarioPlayerEvent.QUIZ_AVAILABLE";
ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE = "ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE";
ScenarioPlayerEvent.PULL_DIALOG_AVAILABLE = "ScenarioPlayerEvent.PULL_DIALOG_AVAILABLE";
ScenarioPlayerEvent.PULL_DIALOG_UNAVAILABLE = "ScenarioPlayerEvent.PULL_DIALOG_UNAVAILABLE";

ScenarioPlayerEvent.CHAT_DIALOG_AVAILABLE = "ScenarioPlayerEvent.CHAT_DIALOG_AVAILABLE";

ScenarioPlayerEvent.NARRATIVE_EVENT_AVAILABLE = "ScenarioPlayerEvent.NARRATIVE_EVENT_AVAILABLE";

ScenarioPlayerEvent.MOVIE_AVAILABLE = "ScenarioPlayerEvent.MOVIE_AVAILABLE";
ScenarioPlayerEvent.CONTENT_COMPLETED = "ScenarioPlayerEvent.CONTENT_COMPLETED";
ScenarioPlayerEvent.SCENARIO_END = "ScenarioPlayerEvent.SCENARIO_END";

ScenarioPlayerEvent.PDA_CONTENT_AVAILABLE = "ScenarioPlayerEvent.PDA_CONTENT_AVAILABLE";
ScenarioPlayerEvent.FILE_CONTENT_AVAILABLE = "ScenarioPlayerEvent.FILE_CONTENT_AVAILABLE";
ScenarioPlayerEvent.FILE_CONTENT_UNAVAILABLE = "ScenarioPlayerEvent.FILE_CONTENT_UNAVAILABLE";
ScenarioPlayerEvent.KEY_MOMENT_AVAILABLE = "ScenarioPlayerEvent.KEY_MOMENT_AVAILABLE";
ScenarioPlayerEvent.NPC_AVAILABLE = "ScenarioPlayerEvent.NPC_AVAILABLE";
ScenarioPlayerEvent.TEXT_AVAILABLE = "ScenarioPlayerEvent.TEXT_AVAILABLE";
ScenarioPlayerEvent.EMAIL_AVAILABLE = "ScenarioPlayerEvent.EMAIL_AVAILABLE";
ScenarioPlayerEvent.DRAFT_EMAIL_AVAILABLE = "ScenarioPlayerEvent.DRAFT_EMAIL_AVAILABLE";
ScenarioPlayerEvent.PUSH_DECISION_DIALOG_AVAILABLE = "ScenarioPlayerEvent.PUSH_DECISION_DIALOG_AVAILABLE";
ScenarioPlayerEvent.TASK_AVAILABLE = "ScenarioPlayerEvent.TASK_AVAILABLE";
ScenarioPlayerEvent.NARRATIVE_EVENT_DIALOG_AVAILABLE = "ScenarioPlayerEvent.NARRATIVE_EVENT_DIALOG_AVAILABLE";
ScenarioPlayerEvent.FEEDBACK_AVAILABLE = "ScenarioPlayerEvent.FEEDBACK_AVAILABLE";
ScenarioPlayerEvent.REFLECTION_AVAILABLE = "ScenarioPlayerEvent.REFLECTION_AVAILABLE";
ScenarioPlayerEvent.CONVERSATION_RESULT_AVAILABLE = "ScenarioPlayerEvent.CONVERSATION_RESULT_AVAILABLE";